import { render, staticRenderFns } from "./SusanoPage.vue?vue&type=template&id=b22037fa"
import script from "./SusanoPage.vue?vue&type=script&lang=js"
export * from "./SusanoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports